var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0009 16.4697V3.57828C21.0009 2.89448 20.7293 2.23868 20.2458 1.75516C19.7623 1.27164 19.1065 1 18.4227 1H8.10953C7.42573 1 6.76993 1.27164 6.28641 1.75516C5.80289 2.23868 5.53125 2.89448 5.53125 3.57828V16.4697C5.53125 17.1535 5.80289 17.8093 6.28641 18.2928C6.76993 18.7763 7.42573 19.048 8.10953 19.048H18.4227C19.1065 19.048 19.7623 18.7763 20.2458 18.2928C20.7293 17.8093 21.0009 17.1535 21.0009 16.4697Z",
    stroke: "#343440",
    strokeWidth: 1.5792,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27933 4.13965L2.69589 5.08072C2.05354 5.31469 1.5304 5.79419 1.24151 6.41379C0.952627 7.03339 0.92164 7.74235 1.15537 8.38479L5.56423 20.4989C5.68007 20.8171 5.85747 21.1093 6.08628 21.359C6.3151 21.6086 6.59085 21.8107 6.8978 21.9538C7.20474 22.0969 7.53686 22.178 7.87518 22.1927C8.21351 22.2074 8.55141 22.1553 8.86959 22.0394L16.0475 19.2058M9.39814 7.4463H15.8438M9.39814 10.0246H17.133M9.39814 12.6029H13.2656",
    stroke: "#343440",
    strokeWidth: 1.5792,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllDocuments);
export default __webpack_public_path__ + "static/media/all-documents.a0f729985c0912170a7ee0a302603126.svg";
export { ForwardRef as ReactComponent };